function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-binoculars",
  "data-name": "Icon awesome-binoculars",
  d: "M52,4.25a2,2,0,0,0-2-2H42a2,2,0,0,0-2,2v6H52Zm-44.011,14C7.675,29.98.433,32.528,0,48.75v5.5a4,4,0,0,0,4,4H16a4,4,0,0,0,4-4v-20h4v-20H11.98A4.038,4.038,0,0,0,7.989,18.249Zm48.022,0a4.038,4.038,0,0,0-3.991-4H40v20h4v20a4,4,0,0,0,4,4H60a4,4,0,0,0,4-4v-5.5c-.433-16.222-7.675-18.77-7.989-30.5ZM22,2.25H14a2,2,0,0,0-2,2v6H24v-6A2,2,0,0,0,22,2.25Zm6,32h8v-20H28Z",
  transform: "translate(0.5 -1.75)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
});

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 57,
    viewBox: "0 0 65 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.06e2d928891414128b1354f8d718af94.svg";
export { ForwardRef as ReactComponent };